/**
 * Enum representing user roles in the system.
 * These roles determine what actions a user can perform.
 */
export enum UserRole {
  Admin = 'cf_admin',
  ContractorPM = 'cf_contractor_pm',
  ContractorInstaller = 'cf_contractor_installer',
}

/**
 * Helper function to check if a user has a specific role.
 */
export const hasRole = (roles: ReadonlyArray<string>, role: UserRole): boolean => {
  return roles.includes(role);
};

/**
 * Helper function to check if a user is an admin.
 */
export const isAdmin = (roles: ReadonlyArray<string>): boolean => {
  return hasRole(roles, UserRole.Admin);
};
